import { Progress } from "@elaniintc/goes-design-system";
import { useInfo } from "../../hooks/use-info";
import { useEffect, useState } from "react";

const ACTIVE_STATUSES = new Set(["IN_PROGRESS", "FAILED", "FINISHED"]);

export default function ProgressBar() {
  const { currentRequestStatus, progress } = useInfo();
  const [maxActiveProgress, setMaxActiveProgress] = useState<number | null>(
    null,
  );

  useEffect(() => {
    if (progress === null || !ACTIVE_STATUSES.has(currentRequestStatus ?? "")) {
      return;
    }

    setMaxActiveProgress(
      (previous) =>
        (previous === null ? progress : Math.max(previous, progress ?? 0)) ??
        null,
    );
  }, [currentRequestStatus, progress]);

  if (maxActiveProgress === null || maxActiveProgress === undefined)
    return null;

  return (
    <div className="flex items-center content-center w-full gap-3 bg-neutral-object-accent-quiet px-3 py-3 rounded-lg">
      <p className="text-nowrap text-body-loud font-semibold text-size-body">
        Avance de Trámite:
      </p>
      <p className="text-body text-size-body font-mono">{maxActiveProgress}%</p>
      <Progress value={maxActiveProgress} />
    </div>
  );
}
